export default __webpack_public_path__ + "static/media/ba.09680458.png";